app.component('medicalResult', {
    templateUrl: 'app/medical/medical_result.html',
    controller: function( $timeout, $location, sharedDataRegionService, odmRecommendService ) {
        var $ctrl = this;
        $ctrl.$onInit = function() {
            var logData = sharedDataRegionService.getLogData();
            var odmSendata = odmRecommendService.getSendData( logData );
            odmRecommendService.getUserRecommend( odmSendata ).then(function(response) {
                $ctrl.recommend_info = response.data;
            },
            function(error) {
                alert(error);
                $location.path("/medical_main");
            });
            $ctrl.doReturn = function() {
                $location.path("/medical_main");
            };
        };
    }
});
